/** Витягує масив з відповіді axios (голий масив або ApiResponseWithData). */
export const extractApiArray = (res) => {
  const raw = res?.data;
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.data)) return raw.data;
  return [];
};

/** Текст помилки з відповіді axios (ApiResponseWithData або Spring). */
export const getApiErrorText = (err, fallback = 'Помилка') => {
  const d = err?.response?.data;
  const msg = d?.errorMessage ?? d?.message ?? d?.data ?? err?.message;
  return (typeof msg === 'string' ? msg : (msg ? JSON.stringify(msg) : fallback)) || fallback;
};
